<div class="surface-section px-4 py-8 md:px-6 lg:px-8">
    <div class="text-700 text-center mb-8">
        <div class="text-900 font-bold text-5xl mb-3">Prenez rendez-vous</div>
        <div class="text-700 text-2xl mb-5">Accédez des maintenant à nos services en recherchant une disponibilité</div>
        <button pButton pRipple (click)="showModal()" type="button" icon="pi pi-calendar-plus" label="Prendre rendez-vous" class="p-button p-button-contrast" severity="contrast"></button>
    </div>
    <hr class="py-4">
    <div class="text-700 text-center bg-transparent">
        <div class="grid grid-cols-12">
            <div class="hidden sm:block col-span-4 rounded-lg h-48 justify-center items-center">
                <span class="inline-flex items-center justify-center border-circle w-20 h-20 mt-4 bg-blue-100 mb-5 rounded-full">
                    <i class="pi pi-user text-4xl text-blue-700"></i>
                </span>
                <div class="text-2xl mb-3 font-medium">Informations</div>
            </div>
            <div [innerHTML]="informations()" class="col-span-12 sm:col-span-8 border-l border-gray-300 text-left pl-8">
            </div>
        </div>
    </div>
</div>

<app-create-meeting-dialog
  [(visible)]="displayModal"
  (created)="onCreated($event)"
  (cancelled)="onCancelled()"
  >
</app-create-meeting-dialog>
